module.exports = __webpack_public_path__ + "static/media/permanent-tbs.c1a2286f.svg";